<template>
  <!-- 云稼农服 -->
  <div>
    <el-carousel :height="computeHeight">
      <el-carousel-item v-for="(item, index) in sliders" :key="index">
        <img :src="item.img" class="banner" />
      </el-carousel-item>
    </el-carousel>

    <div class="introduce_bg">
      <div class="introduce_title">产品介绍</div>
      <div class="introduce_content">
        根据农业生产需求、农产品销售需求、日常生活需求三大方面，为农民提供全方位、综合性、一站式的生产生活服务
      </div>
      <img
        class="product_introduce_img"
        src="../../../static/other/ic_product_introduce.png"
      />
    </div>

    <div class="service_bg">
      <div class="service_title">农业生产服务</div>
      <div class="line" />
      <div class="flow_bg">
        <el-row :gutter="40">
          <el-col :span="6" v-for="(item, index) in service_item" :key="index">
            <div class="flow_item">
              <div class="circle" />
              <div class="flow_item_title">
                {{ item.title }}
              </div>
              <div class="flow_item_content">
                {{ item.content }}
              </div>
              <img class="flow_item_img" :src="item.img" />
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="sales_bg">
      <div class="sales_left">
        <img
          class="sales_left_img"
          src="../../../static/other/ic_sales_left.png"
        />
      </div>
      <div class="sales_right">
        <div class="sales_right_title">农产品销售服务</div>
        <div class="sales_right_content">
          为了使农民更好的完成销售，从提升销售技能、提供销售渠道、增加获客手段、洞察市场行情这四点考虑，云稼农服可提供电商营销培训、农产品采购需求大厅、农产品供应发布渠道、产品认证体系、视频带货、行情分析等功能
        </div>
        <img
          class="sales_right_img"
          src="../../../static/other/ic_sales_right.png"
        />
      </div>
    </div>

    <div class="live_bg">
      <div class="live_title">农民生活服务</div>
      <div class="live_content">
        农民除了进行农业生产，有着生产和农产品销售的需求外，还存在大量的生活需求。从该角度出发，再结合平台自身的特性，平台提供本地教育机构、医疗机构的信息查询功能，并对接第三方服务商，实现网络课程、在线学习、一对一在线问诊、互联网保险服务等功能
      </div>
      <div class="live_bottom">
        <el-row :gutter="10">
          <el-col :span="8" v-for="(item, index) in live_item" :key="index">
            <div class="live_bottom_item">
              <img class="live_bottom_item_img" :src="item.img" />
              <div class="live_bottom_item_title">
                {{ item.title }}
              </div>

              <div class="live_bottom_item_lable">
                <div
                  class="live_bottom_item_lable_bg"
                  v-for="(text, index) in item.content"
                  :key="index"
                >
                  <img
                    class="live_bottom_item_lable_img"
                    src="../../../static/other/ic_live_bottom_item_lable.png"
                  />
                  <div class="live_bottom_item_lable_text">{{ text }}</div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Product",
  data() {
    return {
      sliders: [
        {
          // img: require("../../../static/slider/a1.png"),
          img: require("../../../static/slider/banner.png"),

        },
      ],
      service_item: [
        {
          title: "生产前",
          content: "可为提供种子、化肥、农药等生产投入品的购买服务",
          img: require("../../../static/other/ic_service_item_img1.png"),
        },
        {
          title: "生产中",
          content: "可提供耕种、农药喷洒、收割等农机服务",
          img: require("../../../static/other/ic_service_item_img2.png"),
        },
        {
          title: "生产后",
          content: "可提供运输、存储、农产品加工等服务",
          img: require("../../../static/other/ic_service_item_img3.png"),
        },
        {
          title: "综合服务",
          content:
            "可提供资金贷款、惠农政策、产权交易、农业技能提升、信息交流等服务",
          img: require("../../../static/other/ic_service_item_img4.png"),
        },
      ],

      live_item: [
        {
          title: "在线教育",
          content: ["本地教育机构信息", "本地教育网络课程", "在线学习机构信息"],
          img: require("../../../static/other/ic_live_item1.png"),
        },
        {
          title: "医疗健康",
          content: ["本地医疗机构信息", "一对一在线问诊"],
          img: require("../../../static/other/ic_live_item2.png"),
        },
        {
          title: "保险服务",
          content: ["保险经纪人", "互联网保险服务"],
          img: require("../../../static/other/ic_live_item3.png"),
        },
      ],
    };
  },
  methods: {},
  computed: {
    //计算高度
    computeHeight() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 415) {
        return "500px";
      } else {
        return "250px";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 100%;
}

.introduce_bg {
  width: 100%;
  height: 600px;
  background: #f3f5fa;
  display: flex;
  flex-direction: column;
  align-items: center;
  .introduce_title {
    font-family: "PingFang SC";
    font-weight: 500;
    font-size: 28px;
    line-height: 39px;
    text-align: center;
    color: #333333;
    margin-top: 80px;
    margin-bottom: 8px;
  }
  .introduce_content {
    font-family: "PingFang SC";
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #666666;
  }
  .product_introduce_img {
    width: 1180px;
    height: 317px;
    margin-top: 54px;
  }
}

.service_bg {
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  .service_title {
    font-family: "PingFang SC";
    font-weight: 500;
    font-size: 28px;
    line-height: 39px;
    text-align: center;
    color: #333333;
    margin-top: 80px;
    margin-bottom: 50px;
  }
  .line {
    width: 100%;
    height: 2px;
    background: rgba(51, 112, 255, 0.2);
  }

  .flow_bg {
    display: flex;
    flex-direction: row;
    position: relative;
    top: -8px;
    width: 1180px;

    .flow_item {
      display: flex;
      flex-direction: column;
      align-items: center;

      .circle {
        width: 16px;
        height: 16px;
        border-radius: 8px;
        background-color: #cccccc;
      }

      .flow_item_title {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 20px;
        line-height: 28px;
        text-align: center;
        color: #666666;
        margin-top: 24px;
        margin-bottom: 24px;
      }
      .flow_item_content {
        font-family: "PingFang SC";
        width: 220px;
        height: 70px;
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        color: rgba(153, 153, 153, 0.8);
        margin-bottom: 15px;
      }
      .flow_item_img {
        width: 260px;
        height: 260px;
      }
    }
    .flow_item:hover {
      .circle {
        width: 16px;
        height: 16px;
        border-radius: 8px;
        background-color: #3370ff;
      }

      .flow_item_title {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 20px;
        line-height: 28px;
        text-align: center;
        color: #3370ff;
        margin-top: 24px;
        margin-bottom: 24px;
      }
      .flow_item_content {
        font-family: "PingFang SC";
        width: 220px;
        height: 70px;
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        color: rgba(51, 112, 255, 0.8);
        margin-bottom: 15px;
      }
    }
  }
}
.sales_bg {
  width: 100%;
  background: url("../../../static/other/bg_sales.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center 0;
  display: flex;
  flex-direction: row;
  height: 600px;
  margin-top: 80px;

  .sales_left {
    width: 50%;
    display: flex;
    justify-content: flex-end;

    .sales_left_img {
      width: 449px;
      height: 400px;
      margin-right: 120px;
      margin-top: 200px;
    }
  }
  .sales_right {
    width: 50%;
    display: flex;
    flex-direction: column;

    .sales_right_title {
      font-family: "PingFang SC";
      font-weight: 500;
      font-size: 28px;
      line-height: 39px;
      color: #333333;
      margin-top: 80px;
      margin-bottom: 12px;
    }

    .sales_right_content {
      font-family: "PingFang SC";
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #333333;
      width: 600px;
    }

    .sales_right_img {
      width: 600px;
      height: 180px;
      margin-top: 80px;
    }
  }
}

.live_bg {
  width: 100%;
  height: 600px;
  background: url("../../../static/other/bg_live.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 50px;

  .live_title {
    font-family: "PingFang SC";
    font-weight: 500;
    font-size: 28px;
    line-height: 39px;
    color: #333333;
    margin-top: 80px;
    margin-bottom: 48px;
  }
  .live_content {
    font-family: "PingFang SC";
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #333333;
    width: 878px;
    margin-bottom: 48px;
  }
  .live_bottom {
    display: flex;
    flex-direction: row;
    width: 1180px;
    .live_bottom_item {
      display: flex;
      flex-direction: column;
      align-items: center;

      .live_bottom_item_img {
        width: 118px;
        height: 118px;
      }

      .live_bottom_item_title {
        font-family: "PingFang SC";
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        color: #333333;
        margin-top: 24px;
        margin-bottom: 24px;
      }
      .live_bottom_item_lable {
        display: flex;
        flex-direction: row;
        align-content: space-between;
        flex-wrap: wrap;

        .live_bottom_item_lable_bg {
          display: flex;
          flex-direction: row;
          background: #ffffff;
          border: 1px solid #d6d6d6;
          border-radius: 20px;
          padding-top: 9px;
          padding-bottom: 9px;
          padding-left: 12px;
          padding-right: 12px;

          margin-right: 12px;
          margin-left: 12px;
          margin-bottom: 24px;

          .live_bottom_item_lable_img {
            width: 16px;
            height: 16px;
          }
          .live_bottom_item_lable_text {
            font-family: "PingFang SC";
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #666666;
            margin-left: 8px;
          }
        }
      }
    }
  }
}
</style>